import {Formik} from 'formik';

import {FormWithButtons} from '@flexinet/ui-components';

import {FormComponent} from './FormComponent';
import {RecordSchema} from './RecordSchema';
import {Subscription} from '../types';
import {stage} from '../../../config/stage';

/**
 * FNP-918: `onSubmit` is ASYNC and RETURNS the mutation promise (§6).
 *
 * It was `const onSubmit = (values) => { handleSubmit(values); }` — synchronous,
 * dropping the promise on the floor. Formik then cleared `isSubmitting` on the
 * same tick, so `FormWithButtons`' `disabled={isSubmitting}` never engaged and
 * double-submit was live. The disabled wiring was present and correct the whole
 * time and simply never fired, which is why this survives review (FNP-996).
 */
export const RecordForm = ({
                               record,
                               handleSubmit,
                               handleCancel,
                           }: {
    record: Omit<Subscription, 'id'>,
    handleSubmit: (values: Subscription) => void | Promise<unknown>,
    handleCancel?: () => void
}) => {

    const onSubmit = async (values: Subscription) => await handleSubmit(values);

    const onCancel = () => {
        handleCancel?.();
    };

    let initialValues = {} as Subscription;

    if (record) {
        initialValues = Object.assign({}, initialValues, record);
    }

    return (
        <Formik
            initialValues={initialValues}
            validationSchema={RecordSchema}
            onSubmit={onSubmit}
        >
            {({
                  handleSubmit: formikHandleSubmit,
                  isSubmitting,
                  ...rest
              }) => (
                <FormWithButtons
                    handleSubmit={formikHandleSubmit}
                    isSubmitting={isSubmitting}
                    handleCancel={onCancel}
                    debug={false && stage === 'ide'}
                    {...rest}
                >
                    <FormComponent/>
                </FormWithButtons>
            )}
        </Formik>
    );
};
